"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TraditionalvRothPageTwo;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _TraditionalvRothFormControl = require("./TraditionalvRothFormControl");
var _TraditionalvRothPopovers = require("./TraditionalvRothPopovers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function TraditionalvRothPageTwo() {
  var {
    values: {
      employerMatchYN
    },
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.RetTaxRate, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothPopovers.CustomTaxBracketPopoverModal, null), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.TaxPreference, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothPopovers.CustomRetirementContributionsPopoverModal, null), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.CurrentContribution, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.PlanType, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.EmployerMatchYN, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), employerMatchYN === "doesn't match" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.EmployerMatchRate, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.EmployerMatchLimit, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  })));
}